import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { UserSnsConnection } from '../../interface/I_userSnsConnection';

interface SnsConnectionState {
  data: UserSnsConnection[];
  loading: boolean;
  error: string | null;
}

const initialState: SnsConnectionState = {
  data: [],
  loading: false,
  error: null,
};

const snsConnectionSlice = createSlice({
  name: 'snsConnection',
  initialState,
  reducers: {
    fetchSnsConnectionsStart(state, action: PayloadAction<{ userId: string }>) {
      state.loading = true;
      state.error = null;
      state.data = [];
    },
    fetchSnsConnectionsSuccess(state, action: PayloadAction<UserSnsConnection[]>) {
      state.data = action.payload;
      state.loading = false;
      state.data = [];
    },
    fetchSnsConnectionsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
    },
    addSnsConnectionSuccess(state, action: PayloadAction<UserSnsConnection>) {
      state.data.push(action.payload);
    },
    editSnsConnectionSuccess(state, action: PayloadAction<UserSnsConnection>) {
      const idx = state.data.findIndex((x) => x.id === action.payload.id);
      if (idx !== -1) state.data[idx] = action.payload;
    },
    deleteSnsConnectionSuccess(state, action: PayloadAction<number>) {
      state.data = state.data.filter((x) => x.id !== action.payload);
    },
  },
});

export const {
  fetchSnsConnectionsStart,
  fetchSnsConnectionsSuccess,
  fetchSnsConnectionsFailure,
  addSnsConnectionSuccess,
  editSnsConnectionSuccess,
  deleteSnsConnectionSuccess,
} = snsConnectionSlice.actions;

export default snsConnectionSlice.reducer;
